import { isFuture, isToday } from "date-fns";
import { ensureDateObject } from "./dates";

export function onlyFutureDates(rows, column, includeToday) {
    return rows.filter(row => {
        const dateCol = ensureDateObject(row[column]);
        if(!dateCol) {
            return false;
        }

        if(includeToday) {
            return isToday(dateCol) || isFuture(dateCol);
        }

        return isFuture(dateCol);
    });
}
